<template>
  <div :class="['sui-btn-group', !wrap && merge ? 'el-button-group' : '']">
    <template v-for="(btn, idx) in btnArr">
      <br v-if="idx !== 0 && wrap" :key="idx + 'br'" />
      <sui-prop :key="idx" tag="sui-button" :prop="btn" @click="() => handleBtnClick(btn)"></sui-prop>
    </template>
  </div>
</template>
<script>
import { indexOf } from '../../utils/utils'
export default {
  name: 'SuiButtonGroup',
  props: {
    wrap: {
      type: Boolean
    },
    merge: {
      type: Boolean
    },
    btns: {
      type: Array,
      required: true
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {
    btnArr() {
      let btns = []
      if (this.btns && this.btns.length > 0) {
        this.btns.forEach((btn, i) => {
          if (btn.key === undefined) {
            this.$set(this.btns[i], 'key', i)
          }
          if (btn.visible === undefined) {
            this.$set(this.btns[i], 'visible', true)
          }
          if (btn.disabled === undefined) {
            this.$set(this.btns[i], 'disabled', false)
          }
          if (btn.data === undefined && this.data) {
            this.$set(this.btns[i], 'data', this.data)
          }
          if (typeof btn.click !== 'function') {
            this.$set(this.btns[i], 'click', () => {})
          }
          if (btn['is-test'] === undefined) {
            this.$set(this.btns[i], 'is-test', this.$attrs['is-test'] || false)
          }
          if (this.$attrs['test-id'] !== null && btn['is-test'] === undefined) {
            this.$set(this.btns[i], 'test-id', this.$attrs['test-id'])
          }
          btns.push(btn)
        })
      }
      return btns
    }
  },
  methods: {
    // 禁用 按钮
    disabledBtns(keys) {
      let keyArr = this.getKeyArr(keys)
      this.btns.forEach((btn) => {
        if (indexOf(keyArr, btn.key) !== -1) {
          btn.disabled = true
        }
      })
    },
    // 启用 按钮
    enabledBtns(keys) {
      let keyArr = this.getKeyArr(keys)
      this.btns.forEach((btn) => {
        if (indexOf(keyArr, btn.key) !== -1) {
          btn.disabled = false
        }
      })
    },
    handleBtnClick(btn) {
      this.$emit('click', btn)
      btn.click(btn.data)
    },
    // 隐藏 按钮
    hideBtns(keys) {
      let keyArr = this.getKeyArr(keys)
      this.btns.forEach((btn) => {
        if (indexOf(keyArr, btn.key) !== -1) {
          btn.visible = false
        }
      })
    },
    // 显示 按钮
    showBtns(keys) {
      let keyArr = this.getKeyArr(keys)
      this.btns.forEach((btn) => {
        if (indexOf(keyArr, btn.key) !== -1) {
          btn.visible = true
        }
      })
    },
    getKeyArr(keys) {
      if (!keys) {
        return this.btns.map((btn) => {
          return btn.key
        })
      } else {
        return Array.isArray(keys) ? keys : keys.split(',')
      }
    }
  }
}
</script>
<style lang="scss">
.sui-btn-group {
  .el-button + .el-button {
    margin-left: 8px;
  }
  .el-button--text + .el-button--text {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/basic/SuiButtonGroup.vue